// extracted by mini-css-extract-plugin
export default {"list":"List_list__lyyVk","checkmark":"List_checkmark__0jZkj"};